import { withI18n } from '@lingui/react'

import { isEmpty } from 'shared/utils/objectUtils'
import at from 'views/assets/images/flags/flag-austria.svg'
import fr from 'views/assets/images/flags/flag-france.svg'
import de from 'views/assets/images/flags/flag-germany.svg'
import it from 'views/assets/images/flags/flag-italy.svg'
import es from 'views/assets/images/flags/flag-spain.svg'
import IconTick from 'views/components/atoms/Icon/IconTick'
import { getLanguagesOptions } from 'views/components/organisms/LanguageSwitcher/utils'
import { i18nType } from 'views/utils/propTypes'
import {
  usePageProperties,
  usePublicConfig,
} from 'views/utils/shopAndRuntimeConfigUtils'

import './LanguageSwitcherMobile.scss'

const flags = {
  fr,
  de,
  at,
  it,
  es,
}

const LanguageSwitcherMobile = ({ i18n }) => {
  const { language } = usePublicConfig()
  const { alternativeUrls = {} } = usePageProperties()

  if (isEmpty(alternativeUrls)) {
    return null
  }

  const shopLanguages = getLanguagesOptions(language, alternativeUrls, i18n)

  return (
    <ul className="a-list-reset">
      {shopLanguages.map(language => (
        <li key={language.code} className="o-LanguageSwitcherMobile__item">
          <a
            href={language.href}
            className="
            u-display--block
            a-link--neutral
            u-padding-large--sides
            u-padding-small--top
            u-padding-small--bottom"
          >
            <div className="l-flex l-flex--distribute-space">
              <div>
                <div className="u-display--inline-block u-margin--right u-vertical-align--middle">
                  <img src={flags[language.code]} alt="" />
                </div>
                <span className="u-vertical-align--middle u-font-weight--bold">
                  {language.text}
                </span>
              </div>
              <div className="o-LanguageSwitcherMobile__icon u-margin-small--right">
                {language.selected && (
                  <IconTick size="small" className="u-color--positive" />
                )}
              </div>
            </div>
          </a>
        </li>
      ))}
    </ul>
  )
}

LanguageSwitcherMobile.propTypes = {
  i18n: i18nType.isRequired,
}

// TODO Remove if unused after the CH shop migrated to Fock
export default withI18n()(LanguageSwitcherMobile)
